import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  HttpTypes,
  InternalServerError,
  TooManyRequestsError,
  UnexpectedError,
} from 'src/http';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { shopkeeperManager } from 'src/types/users';
import { endpoints } from 'src/utils/axios';
import { Either } from 'src/utils/either';

export class ShopkeepersRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getShopkeepersList(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.users.shopkeepersList,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getShopkeeperDetails(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.users.shopkeeperDetails(id),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updateShopkeeper(
    shopkeeper: shopkeeperManager
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.users.updateShopkeeper,
      body: shopkeeper,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async registerShopkeeper(
    shopkeeper: shopkeeperManager
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.users.registerShopkeeper,
      body: shopkeeper,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
